import { render, staticRenderFns } from "./EpisodeSlide.vue?vue&type=template&id=0545dfa6&scoped=true"
import script from "./EpisodeSlide.vue?vue&type=script&lang=js"
export * from "./EpisodeSlide.vue?vue&type=script&lang=js"
import style0 from "./EpisodeSlide.vue?vue&type=style&index=0&id=0545dfa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0545dfa6",
  null
  
)

export default component.exports